export default {
  fetchError: 'Erreur lors du chargement de l\'emprunt',
  loading: 'Chargement de l\'emprunt...',
  errorTitle: 'Erreur',
  notFound: 'Emprunt introuvable',
  reservation: 'Réservation',
  borrowing: 'Emprunt',
  borrowingDetails: 'Détails de l\'Emprunt',
  reservationDetails: 'Détails de la Réservation',
  borrower: 'Emprunteur',
  reservedFrom: 'Réservé Depuis',
  reservedUntil: 'Réservé Jusqu\'au',
  reservedFromTo: 'Période de Réservation',
  reservationDate: 'Date de Réservation',
  reservationDuration: 'Durée de Réservation',
  borrowedAt: 'Emprunté le',
  expectedReturnAt: 'Retour Prévu',
  returnedAt: 'Retourné le',
  duration: 'Durée d\'Emprunt',
  createdAt: 'Créé le',
  updatedAt: 'Dernière Mise à Jour',
  since: 'Depuis le',
  notes: 'Notes',
  borrowingNotes: 'Notes d\'Emprunt',
  reservationNotes: 'Notes de Réservation',
  returnNotes: 'Notes de Retour',
  returnResource: 'Retourner la Ressource',
  startReservation: 'Commencer la Réservation et Emprunter',
  editReservation: 'Modifier la Réservation',
  deleteReservation: 'Supprimer la Réservation',
  borrowResource: 'Emprunter la Ressource',
  viewResource: 'Voir la Ressource',
  noImage: 'Aucune Image',
  timelineTitle: 'Chronologie',
  timeline: {
    reserved: 'Ressource Réservée',
    borrowed: 'Ressource Empruntée',
    expectedReturn: 'Retour Prévu',
    returned: 'Ressource Retournée',
    overdue: 'En Retard',
    by: 'par'
  },
  status: {
    reserved: 'Réservé',
    reservationActive: 'Réservation en Cours',
    reservationExpired: 'Réservation Expirée',
    borrowedActive: 'Emprunt en Cours',
    overdue: 'En Retard',
    returned: 'Retourné',
    pendingValidation: 'En Attente de Validation',
    validationRejected: 'Validation Refusée',
    available: 'Disponible',
    unavailable: 'Indisponible'
  },
  durationData: {
    oneDay: '1 jour',
    days: '{{count}} jours',
    oneWeek: '1 semaine',
    weeks: '{{count}} semaines',
    oneMonth: '1 mois',
    months: '{{count}} mois',
    weeksAndDays: '{{weeks}} semaines et {{days}} jours'
  }
};
